
"use client";

import { trackScrollDepth } from "@/lib/analytics/ga-events";
import { useEffect, useRef } from "react";


interface ScrollDepthTrackerProps {
  articleSlug: string;
}

const ScrollDepthTracker = ({ articleSlug }: ScrollDepthTrackerProps) => {
  const trackedDepths = useRef<Set<number>>(new Set());

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;

      const milestones = [25, 50, 75, 100];

      milestones.forEach((milestone) => {
        if (scrollPercent >= milestone && !trackedDepths.current.has(milestone)) {
          trackedDepths.current.add(milestone);
          trackScrollDepth(milestone as 25 | 50 | 75 | 100, articleSlug);
  
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [articleSlug]);

  return null; 
};

export default ScrollDepthTracker;
